/* Barley Moon funnel helpers: one-tap add for bundle + add-on cards */
(function () {
  if (window.__bmbFunnelInit) return;
  window.__bmbFunnelInit = true;

  async function addVariant(variantId, openCart) {
    const gid = 'gid://shopify/ProductVariant/' + variantId;
    const actions = window.Shopify && window.Shopify.actions;
    if (actions && actions.updateCart) {
      const result = await actions.updateCart({ lines: [{ merchandiseId: gid, quantity: 1 }] });
      if (result && result.userErrors && result.userErrors.length) throw new Error(result.userErrors[0].message);
      if (openCart && actions.openCart) await actions.openCart();
      return;
    }
    const res = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });
    if (!res.ok) throw new Error('Could not add to cart');
    window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-bmb-add]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;
    const label = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.addingLabel || 'Adding…';
    try {
      await addVariant(button.dataset.bmbAdd, button.dataset.openCart === 'true');
      button.textContent = button.dataset.addedLabel || 'Added';
      setTimeout(function () {
        button.innerHTML = label;
        button.disabled = false;
      }, 1800);
    } catch (error) {
      button.innerHTML = label;
      button.disabled = false;
      const message = button.closest('[data-bmb-card]')?.querySelector('[data-bmb-error]');
      if (message) {
        message.textContent = error.message || 'Something went wrong. Please try again.';
        message.hidden = false;
      }
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
})();
